<template>
  <div class="table-container-main">
    <div class="confirm-svg">
        <svg style="padding-left: 5px;" height="50px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 180.36">
            <g id="image">
                <path d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09,0,0,0,0,0,0C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z" style="fill: #000; fill-rule: evenodd;"/>
            </g>
        </svg>
        <h2>Closed Trip Sheets</h2>
    </div>
    <table-filter :showDateRange="true" :filterByDateRange="true" :filterByTripSheetID="true" :filterByRouteCode="true" @filterValues="filterValues($event)"/>
    <div class="responsive-table">
        <div class="table-header" id="header">
            <div class="col-1">Trip Sheet</div>
            <div class="col-2">Route Code</div>
            <div class="col-3">Closed On</div>
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div class="table-row-container">
            <div class="table-row" v-for="(tripSheet, index) in closedTripSheetTableData" :key="index">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text" @click="getUserDataClick(tripSheet.TripSheetId)">{{tripSheet.TripSheetId}}</p></div>
                <div class="col-2"><p class="service-text">{{tripSheet.routeCode}}</p></div>
                <div class="col-3"><p class="service-text">{{tripSheet.closedOn}}</p></div>
            </div>
            <div v-if="closedTripSheetTableData.length == 0" class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Routes</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
            </div>
        </div>
    </div>
  </div>
<trip-sheet-info v-if="toggleAddressBookInfo" @closeAddressInfo="closeAddressInfo($event)" :selectedTripSheetID="selectedTripSheetID" :serviceNetwork="serviceNetwork" :cognitoUser="user"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import AlertUser from '../../Popups/AlertUser.vue';
import LoadingCharts from '../LoadingCharts.vue'
import TripSheetInfo from '../TripSheetDashboard/TripSheetInfo.vue'
import TableFilter from '../TableFilter.vue'

export default {
    components:{
        AlertUser,
        LoadingCharts,
        TripSheetInfo,
        TableFilter
    },
    props: ['userData', 'jwtToken', 'user'],
    watch:{
        'userData':function(){
            if(this.userData)
            {
                this.listClosedTripSheetsByDate();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user data to generate table."
            }
        }
    },
    mounted(){
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - 3);

        this.endDate = end.toLocaleDateString('en-CA');
        this.startDate = start.toLocaleDateString('en-CA');
        if(this.userData){
            this.listClosedTripSheetsByDate();
        }

        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, "", cleanUrl);
    },
    data(){
        return{
            toggleAddressBookInfo: false,
            toggleRouteUpdateList: false,
            id: null,
            selectedTripSheetID: null,
            serviceNetwork: null,
            closedTripSheetTableData: [],
            loadingTable: false,
            toggleAlertBox: '',
            alertMessage: '',
            selectedIndex: null,
            filterField: null,
            filterValue: null,
            filterEvent: null,
            isFiltered: false,
            selectedGeoServiceNetworkItems: [],
            selectAllChecked: false,
            startDate: null,
            endDate: null
        }
    },
    methods:{
        async filterValues(event){
            console.log(event)
            this.isFiltered = true;
            this.filterEvent = event;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;
            this.startDate = event.startDate;
            this.endDate = event.endDate;

            switch (event.filterField) {
                case "routeCode":
                    await this.listClosedTripSheetsByRouteAndDate(event.filterValue, this.startDate, this.endDate, 100);
                    break;
                case "dateRange":
                    await this.listClosedTripSheetsByDate();
                    break;
                case "tripSheetID":
                    await this.getTripSheetByID(event.filterValue);
                    break;
                default:
                    break;
            }
        },
        // async listClosedTripSheetsByRouteAndDate(routeCode, startDate, endDate, pageSize = 200) {
        //     this.loadingTable = true;

        //     const graphqlQuery = /* GraphQL */ `
        //         query ListTripSheetsByRouteAndClosedOn(
        //         $routeCode: String!
        //         $start: String!
        //         $end: String!
        //         $limit: Int
        //         $nextToken: String
        //         ) {
        //         listTripSheets(
        //             filter: {
        //             and: [
        //                 { routeCode: { eq: $routeCode } }
        //                 { closedOn: { between: [$start, $end] } }
        //             ]
        //             }
        //             limit: $limit
        //             nextToken: $nextToken
        //         ) {
        //             items {
        //             TripSheetId
        //             routeCode
        //             closedOn
        //             openSince
        //             driverCode
        //             vehicleCode
        //             RouteId
        //             VehicleId
        //             DriverId
        //             TripDate
        //             SignOffDate
        //             StartingMileage
        //             EndingMileage
        //             ManifestSource
        //             openManifestAction
        //             }
        //             nextToken
        //         }
        //         }
        //     `;

        //     let nextToken = null;
        //     const allItems = [];

        //     try {
        //         // optional defensives
        //         const rc = (routeCode ?? "").trim();
        //         if (!rc) throw new Error("Route code is required.");

        //         do {
        //         const resp = await API.graphql({
        //             query: graphqlQuery,
        //             variables: {
        //             routeCode: rc,
        //             start: startDate,
        //             end: endDate,      
        //             limit: pageSize,
        //             nextToken,
        //             },
        //             authMode: "AMAZON_COGNITO_USER_POOLS",
        //         });

        //         const payload = resp?.data?.listTripSheets ?? {};
        //         const items = payload?.items ?? [];
        //         nextToken = payload?.nextToken ?? null;

        //         allItems.push(...items);
        //         } while (nextToken);

        //         this.closedTripSheetTableData = allItems;
        //     } catch (e) {
        //         console.log(e);
        //         this.toggleAlertBox = true;
        //         this.alertMessage = "Error getting trip sheets";
        //     } finally {
        //         this.loadingTable = false;
        //         this.isFiltered = false;
        //     }
        // },
        async listClosedTripSheetsByRouteAndDate(routeCode, startDate, endDate, pageSize = 500) {
            this.loadingTable = true;

            const graphqlQuery = /* GraphQL */ `
                query TripSheetsByClosedOn(
                    $closedOn: String!
                    $limit: Int
                    $nextToken: String
                ) {
                    tripSheetByClosedOn(
                        closedOn: $closedOn
                        limit: $limit
                        nextToken: $nextToken
                    ) {
                        items {
                            TripSheetId
                            routeCode
                            closedOn
                            openSince
                            driverCode
                            vehicleCode
                            RouteId
                            VehicleId
                            DriverId
                            TripDate
                            SignOffDate
                            StartingMileage
                            EndingMileage
                            ManifestSource
                            openManifestAction
                        }
                        nextToken
                    }
                }
            `;

            try {
                const rc = (routeCode ?? "").trim();
                if (!rc) throw new Error("Route code is required.");

                const dates = this.getDatesBetween(startDate, endDate);
                const concurrency = 5;

                const fetchDate = async (closedOn) => {
                    const dateItems = [];
                    let nextToken = null;

                    do {
                        const resp = await API.graphql({
                            query: graphqlQuery,
                            variables: {
                                closedOn,
                                limit: pageSize,
                                nextToken,
                            },
                            authMode: "AMAZON_COGNITO_USER_POOLS",
                        });

                        const payload = resp?.data?.tripSheetByClosedOn ?? {};
                        const items = payload?.items ?? [];

                        dateItems.push(
                            ...items.filter(item =>
                                (item?.routeCode ?? "").trim() === rc
                            )
                        );

                        nextToken = payload?.nextToken ?? null;
                    } while (nextToken);

                    return dateItems;
                };

                const allItems = [];

                for (let i = 0; i < dates.length; i += concurrency) {
                    const batch = dates.slice(i, i + concurrency);
                    const results = await Promise.all(batch.map(fetchDate));
                    allItems.push(...results.flat());
                }

                this.closedTripSheetTableData = allItems;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = e.message || "Error getting trip sheets";
            } finally {
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async getUserDataClick(id, serviceNetwork){
            this.$emit('selectTripSheetID', {selectedTripSheetID: id})
            console.log(serviceNetwork)
        },
        closeAddressInfo(event){
            this.toggleAddressBookInfo = event;
            this.toggleRouteUpdateList = event;
            this.selectedGeoServiceNetworkItems = [];
            this.selectAllChecked = false;
            if(this.isFiltered == true){
                this.filterValues(this.filterEvent);
            }else{
                this.listClosedTripSheetsByDate();
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        // async listOpenTripSheetData(){
        //     this.loadingTable = true;
        //     let graphqlQuery = `mutation getOpenTripSheetMutation {
        //             getOpenTripSheet(input: {filterItems: false}) {
        //                 openSince
        //                 routeCode
        //                 TripSheetId
        //             }
        //         }`
            
        //     try{
        //         let listTripSheetDataReturn = await API.graphql({
        //         query:  graphqlQuery,
        //         authMode: "AMAZON_COGNITO_USER_POOLS",
        //         })
                
        //         this.closedTripSheetTableData = listTripSheetDataReturn.data.getOpenTripSheet;
        //     }catch(e){
        //         console.log(e)
        //         if(e){
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Error getting trip sheets"
        //         }
        //     }finally{
        //         this.loadingTable = false;
        //         this.isFiltered = false;
        //     }
        // },
        getDatesBetween(start, end) {
            const MAX_DAYS = 31;

            const dates = [];
            const current = new Date(`${start}T00:00:00`);
            const last = new Date(`${end}T00:00:00`);

            if (isNaN(current) || isNaN(last)) {
                throw new Error("Invalid date range.");
            }

            // normalize order
            if (current > last) {
                return this.getDatesBetween(end, start);
            }

            const diffDays = Math.ceil((last - current) / (1000 * 60 * 60 * 24)) + 1;

            if (diffDays > MAX_DAYS) {
                throw new Error("Date range cannot exceed 31 days.");
            }

            while (current <= last) {
                dates.push(current.toISOString().slice(0, 10));
                current.setDate(current.getDate() + 1);
            }

            return dates;
        },
        async listClosedTripSheetsByDate(pageSize = 100) {
            this.loadingTable = true;

            const graphqlQuery = /* GraphQL */ `
                query TripSheetsByClosedOn(
                    $closedOn: String!
                    $limit: Int
                    $nextToken: String
                ) {
                    tripSheetByClosedOn(
                        closedOn: $closedOn
                        limit: $limit
                        nextToken: $nextToken
                    ) {
                        items {
                            openSince
                            routeCode
                            TripSheetId
                            closedOn
                            driverCode
                            vehicleCode
                            openManifestAction
                        }
                        nextToken
                    }
                }
            `;

            try {
                const dates = this.getDatesBetween(this.startDate, this.endDate);
                const concurrency = 5; // tweak this (3–10 is usually safe)

                const fetchDate = async (closedOn) => {
                    const dateItems = [];
                    let nextToken = null;

                    do {
                        const resp = await API.graphql({
                            query: graphqlQuery,
                            variables: {
                                closedOn,
                                limit: pageSize,
                                nextToken,
                            },
                            authMode: "AMAZON_COGNITO_USER_POOLS",
                        });

                        const payload = resp?.data?.tripSheetByClosedOn ?? {};
                        dateItems.push(...(payload.items ?? []));
                        nextToken = payload?.nextToken ?? null;

                    } while (nextToken);

                    return dateItems;
                };

                const allItems = [];

                // process in batches to avoid hammering API
                for (let i = 0; i < dates.length; i += concurrency) {
                    const batch = dates.slice(i, i + concurrency);
                    const results = await Promise.all(batch.map(fetchDate));
                    allItems.push(...results.flat());
                }

                this.closedTripSheetTableData = allItems;

            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = e.message || "Error getting trip sheets";
            } finally {
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        // async listClosedTripSheetsByDate(pageSize = 20) {
        //     this.loadingTable = true;

        //     const graphqlQuery = /* GraphQL */ `
        //         query ListTripSheetsClosedOnBetween(
        //         $start: String!
        //         $end: String!
        //         $limit: Int
        //         $nextToken: String
        //         ) {
        //         listTripSheets(
        //             filter: { closedOn: { between: [$start, $end] } }
        //             limit: $limit
        //             nextToken: $nextToken
        //         ) {
        //             items {
        //             openSince
        //             routeCode
        //             TripSheetId
        //             closedOn
        //             driverCode
        //             vehicleCode
        //             openManifestAction
        //             }
        //             nextToken
        //         }
        //         }
        //     `;

        //     let nextToken = null;
        //     const allItems = [];

        //     try {
        //         do {
        //         const resp = await API.graphql({
        //             query: graphqlQuery,
        //             variables: {
        //             start: this.startDate,
        //             end: this.endDate,
        //             limit: pageSize,
        //             nextToken
        //             },
        //             authMode: "AMAZON_COGNITO_USER_POOLS",
        //         });

        //         const payload = resp?.data?.listTripSheets ?? {};
        //         const items = payload?.items ?? [];
        //         nextToken = payload?.nextToken ?? null;

        //         allItems.push(...items);
        //         } while (nextToken);

        //         // assign to your table data
        //         this.closedTripSheetTableData = allItems;
        //     } catch (e) {
        //         console.log(e);
        //         this.toggleAlertBox = true;
        //         this.alertMessage = "Error getting trip sheets";
        //     } finally {
        //         this.loadingTable = false;
        //         this.isFiltered = false;
        //     }
        // },
        async getTripSheetByID(filterValue){
            this.loadingTable = true;
            this.closedTripSheetTableData = []
            let graphqlQuery = `query MyQuery {
                getTripSheet(TripSheetId: ${filterValue}) {
                    routeCode
                    openSince
                    TripSheetId
                }
            }`
            
            try{
                let getTripSheetData = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.closedTripSheetTableData.push(getTripSheetData.data.getTripSheet)
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting trip sheets"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        }
    }
}
</script>

<style scoped>
h3{
    margin: 0;
}
.table-container-main{
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
}

.responsive-table{
    width: 100%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
    margin-bottom: 5px;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

* {
    scrollbar-width: auto;
    scrollbar-color: #f3f3f3 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: #ffffff;
}

*::-webkit-scrollbar-thumb {
    background-color: #f3f3f3;
    border-radius: 10px;
    border: 3px solid #ffffff;
}

.table-header{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #32ccfe;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
    color: #fff;
}

.table-row-container{
    max-height: 350px;
    overflow-y: auto;
    border-radius: 5px;
    width: 100%;
    animation: animate-table-row 1s ease;
}

@keyframes animate-table-row{
    from{
        margin-left: -50px;
    }
    to{
        margin-left: 0px;
    }
}

.table-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f3f3f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
}

.table-header .col-1{
    margin-right: 5px;
}

.col-1{
    flex-basis: 20%;
    text-align: left;
    /* white-space: nowrap; */
}

.col-2{
    flex-basis: 40%;
    text-align: left;
    margin-left: 5px;
}

.col-3{
    flex-basis: 30%;
    text-align: left;
    margin-left: 5px;
}

.col-data{
    text-align: left;
    max-height: 40px;
    overflow-y: auto;
    border: 1px solid #a0a0a0;
    border-radius: 5px 0px 0px 5px;
}

.col-data p{
    overflow-x: auto;
    margin-top: 5px;
    margin-bottom: 5px;
}

.col-4{
    flex-basis: 10%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.service-text{
    background-color: #d4d4d4;
    padding: 2.5px 10px;
    border-radius: 999px;
    width: fit-content;
    margin: 0;
    font-size: 12px;
}

.shipmentid-text{
    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.shipmentid-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.print-selected-text{
    margin: 0;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.download-csv{
    margin-top: 5px;
}

.void-selected-text{
    margin: 0;
    margin-bottom: 5px;
    padding: 2.5px 10px;
    margin-bottom: 5px;
    border-radius: 999px;
    background-color: #fe804d;
    border: 1px solid #ff5512;
    color: #fff;
    transition-duration: .5s;
}

.print-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.void-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.close-label{
    margin-left: auto;
}

.label-container{
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .service-text, .col-data{
        font-size: 8px;
    }

    .shipmentid-text{
        font-size: 10px;
    }
}
</style>